// Legacy JavaScript entrypint for Vite, originally app/javascript/application.js
import "@/legacy/behaviors";
import "@/legacy/controllers";
import "@/legacy/utils/confirmDialog";
import "@hotwired/stimulus";
import "@hotwired/turbo-rails";
import "@rails/actiontext";
import "@rails/activestorage";
// tracking/analytics

import ahoy from "ahoy.js";
import "bootstrap";
// eslint-disable-next-line no-unused-vars
import Trix from "trix";

ahoy.configure({
  cookies: false,
});

document.addEventListener("turbo:load", () => {
  ahoy.trackView();
  // ahoy.trackSubmits("form[data-submit-tracking=true]");

  // Scroll to anchor after Turbo Drive navigation (e.g. backoffice edit links with #section-*)
  const hash = window.location.hash;
  if (hash) {
    requestAnimationFrame(() => {
      const target = document.querySelector(hash);
      if (target) {
        target.scrollIntoView({ behavior: "instant" });
      }
    });
  }
});

// Old: data-click-tracking="true" (backward compatible)
// New: data-track="semantic_name" for additional semantic identification
document.addEventListener(
  "click",
  (event) => {
    const target = event.target.closest(
      "[data-track], [data-click-tracking=true]"
    );
    if (!target) return;

    const sectionEl = target.closest("[data-section]");

    ahoy.track("$click", {
      // Standard ahoy properties (backward compatible)
      tag: target.tagName.toLowerCase(),
      id: target.id ?? undefined,
      class: target.className ?? undefined,
      page: window.location.pathname,
      section: sectionEl?.getAttribute("data-section") ?? undefined,
      text:
        target.tagName === "INPUT"
          ? target.value
          : target.textContent?.trim().substring(0, 100),
      href: target.getAttribute("href") ?? undefined,
      // Semantic identifier (new) - use alongside id for flexibility
      name: target.getAttribute("data-track") ?? undefined,
    });
  },
  true
);
// Required for google places api script callback function defined in app/layout/backoffice.html.erb
window.dispatchMapsEvent = function handleEvent(...args) {
  const event = document.createEvent("Events");
  event.initEvent("google-maps-callback", true, true);
  event.args = args;
  window.dispatchEvent(event);
};
